import {
  NgModule
} from '@angular/core';
import {
  ButtonsModule
} from '@progress/kendo-angular-buttons';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {FloatingLabelModule, LabelModule} from '@progress/kendo-angular-label';
import {GridModule} from '@progress/kendo-angular-grid';
import {CheckBoxModule, NumericTextBoxModule, SwitchModule} from '@progress/kendo-angular-inputs';
import {CommonModule} from '@angular/common';
import {DealItemDetailComponent} from './deal-item-detail.component';
import {DropDownListModule} from '@progress/kendo-angular-dropdowns';

@NgModule({
  declarations: [
    DealItemDetailComponent
  ],
  imports: [
    ButtonsModule,
    ReactiveFormsModule,
    FormsModule,
    DropDownListModule,
    GridModule,
    LabelModule,
    NumericTextBoxModule,
    SwitchModule,
    CommonModule,
    CheckBoxModule,
    FloatingLabelModule
  ],
  exports: [
    DealItemDetailComponent
  ],
  providers: [
  ],
  entryComponents: [
  ]
})
export class DealItemDetailModule {
}
